var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 59,
    viewBox: "0 0 33 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8095 17.7142C30.7513 16.3737 29.9171 15.0828 28.462 14.3546L28.1904 14.2222C29.0052 14.5697 29.7037 15.0993 30.1887 15.811C30.5767 16.4233 30.7901 17.0688 30.8095 17.7142Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89504 2.60669L28.1905 13.6246C26.8663 12.971 25.2394 12.971 23.8585 13.774L16.9726 17.7143L4.29819 10.4686C2.10381 9.21743 1.34713 6.43494 2.61457 4.26871C3.90093 2.10248 6.70066 1.3555 8.89504 2.60669Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8095 17.7144C30.7901 18.5212 30.5767 19.328 30.1693 20.0934C29.6843 20.983 28.9858 21.6657 28.1904 22.0794L28.462 21.9139C29.9171 21.0037 30.7513 19.39 30.8095 17.7144Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8095 40.9065C30.8095 42.4954 29.976 44.0459 28.5172 44.9074L27.9867 45.2136L8.9093 56.3738C6.71169 57.6564 3.88892 56.9098 2.61961 54.6701C1.35031 52.4496 2.08916 49.5973 4.3057 48.3148L14.8769 42.1317C15.8052 41.5957 15.8052 40.2365 14.8769 39.6814L4.49515 33.6132L4.3057 33.4983C2.88484 32.656 2.05127 31.1629 2.01338 29.6124C2.01338 29.5166 2.01338 29.4209 2.01338 29.3252C2.07021 27.7747 2.88484 26.2815 4.3057 25.4392L4.49515 25.3244L16.9987 18.0119L23.8947 13.9728C25.2776 13.1688 26.9069 13.1688 28.233 13.8196L28.4983 13.9728C29.9191 14.8151 30.7527 16.3082 30.7906 17.8587C30.7906 17.9545 30.7906 18.0502 30.7906 18.1459C30.7337 19.6964 29.9191 21.1896 28.4983 22.0318L28.233 22.185L17.8891 28.2341C16.9609 28.7701 16.9609 30.1292 17.8891 30.6843L27.9489 36.5803L28.4983 36.8866C29.9759 37.7671 30.7906 39.3177 30.8095 40.9065Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a76cf124769e378ce9fcd26478cfbecf.svg";
export { ForwardRef as ReactComponent };